import './MovementDetails.scss';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

// MovementDetails Screen Component
const MovementDetails = ({ movement, category, job }) => {
  return (
    <div className="movement_information">
      {category == 'international' ? (
        <>
          <div className="groupage">Groupage:</div>
          <div className="value">{movement?.reference || '(No Groupage)'}</div>
          {movement?.prioritise && (
            <div className="priority">
              <FontAwesomeIcon icon={faCircleExclamation} /> This trailer is high priority
            </div>
          )}
          <div className="job_ref">Trailer ID:</div>
          <div className="value">{movement?.vehicleRegistration || 'N/A'}</div>
          <div className="job_haulier">Haulier:</div>
          <div className="value">{movement?.supplier?.name || 'Not Specified'}</div>
          <div className="job_consignee">Type:</div>
          <div className="value">{movement?.trailerType?.name || 'N/A'}</div>
          <div className="job_consignee">Partner:</div>
          <div className="value">
            {job?.partner?.name
              ? movement?.assignments.every(
                  assignment => assignment?.job?.partner?.name == job?.partner?.name,
                )
                ? job?.partner?.name
                : 'Various'
              : 'Not Specified'}
          </div>
        </>
      ) : (
        <>
          <div className="job_ref">Job Ref:</div>
          <div className="value">{job?.jobReference}</div>
          <div className="job_controller">Controller:</div>
          <div className="value">
            {job?.jobController?.firstName || job?.jobController?.lastName
              ? `${job?.jobController?.firstName || ''} ${job?.jobController?.lastName || ''}`
              : 'N/A'}
          </div>
          <div className="job_shipper">Shipper:</div>
          <div className="value">
            {job?.shipper
              ? `${job?.shipper?.name} ${job?.shipper?.businessType?.shortForm || ''}`
              : 'Not Specified'}
          </div>
          <div className="job_consignee">Consignee:</div>
          <div className="value">
            {job?.consignee
              ? `${job?.consignee?.name} ${job?.consignee?.businessType?.shortForm || ''}`
              : 'Not Specified'}
          </div>
          <div className="job_haulier">Haulier:</div>
          <div className="value">{movement?.supplier?.name || 'Not Specified'}</div>
          <div className="job_consignee">Trailer:</div>
          <div className="value">{movement?.trailerType?.name || 'N/A'}</div>
          <div className="job_marks_nos">Marks/Nos: </div>
          <div className="value">
            {job?.marksLine1 || job?.marksLine2 || job?.marksLine3 || job?.marksLine4
              ? `${job?.marksLine1}
            ${job?.marksLine2 ? `, ${job?.marksLine2}` : ''}
            ${job?.marksLine3 ? `, ${job?.marksLine3}` : ''}
            ${job?.marksLine4 ? `, ${job?.marksLine4}` : ''}`
              : 'N/A'}
          </div>
        </>
      )}
    </div>
  );
};

MovementDetails.propTypes = {
  movement: PropTypes.object,
  category: PropTypes.string,
  job: PropTypes.object,
};

export default MovementDetails;
